/** @module ProductSpec/AggregateSizeChartSubSizeIncrement */
define([
	"dojo/_base/declare",
	"csi/heading/AggregateController",
	"csi/widget/MessageDialog",
	"csi/xml"
], function(declare, AggregateController, MessageDialog, xml) {

	return declare(AggregateController, {

		getConfirmButton: function() {
			return MessageDialog.BUTTON_CHANGE;
		},

		/**
		 * Process when Increment change is confirmed
		 * @param {String} key
		 */
		onConfirm: function(key) {
			if (key == MessageDialog.BUTTON_CHANGE) {
				AggregateController.prototype.publish.call(this);
			} else {
				this.postProcess();
			}
		},

		/**
		 * If SizeChart has an Increment confirm action before changing/deselect Increment
		 */
		publish: function() {
			var newIncrementUrl = this.newValue;
			var oldIncrementUrl = this.oldValue;

			if (oldIncrementUrl != newIncrementUrl && xml.isValidURL(oldIncrementUrl)) {
				this.confirmAction({});
			} else {
				this.inherited(arguments);
			}
		}
	});
});